import React from 'react';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useIntl } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';
import { messages } from './messages.tsx';

export const PROJECT_LEFT_ICON_TEST_ID =
	'command-palette-common.common.ui.command.project.project-left-icon.img';

// Remove name prop when cleaning up deliveroo_compal_a11y_fixes
export const ProjectLeftIcon = ({
	url,
	name,
}: {
	url: string;
	name?: string;
}): React.JSX.Element => {
	const issueIconAltTextGalaxia = expVal('project-terminology-refresh', 'isEnabled', false)
		? messages.issueIconAltTextGalaxia
		: messages.issueIconAltText;
	const { formatMessage } = useIntl();
	return (
		<img
			data-testid={fg('deliveroo_compal_a11y_fixes') ? PROJECT_LEFT_ICON_TEST_ID : undefined}
			src={url}
			alt={
				fg('deliveroo_compal_a11y_fixes')
					? ''
					: formatMessage(issueIconAltTextGalaxia, {
							name,
						})
			}
			height="16"
			aria-hidden={fg('deliveroo_compal_a11y_fixes') ? true : undefined}
		/>
	);
};
